import { supabase } from "./supabase";

class ProfileService {
  async getProfile(userId) {
    try {
      console.log("Fetching profile for:", userId);
      
      const { data, error } = await supabase
        .from("user_profiles")
        .select("*")
        .eq("id", userId)
        .maybeSingle(); // Use maybeSingle instead of single to handle no rows

      if (error) {
        console.error("Error fetching profile:", error);
        throw error;
      }
      
      if (!data) {
        console.log("No profile found, will be created on first update");
        return null;
      }
      
      console.log("Profile fetched:", data);
      return data;
    } catch (error) {
      console.error("Failed to fetch profile:", error);
      return null;
    }
  }

  async updateProfile(userId, updates) {
    try {
      console.log("Updating profile for:", userId, "with:", updates);
      
      // Use upsert to create or update
      const { data, error } = await supabase
        .from("user_profiles")
        .upsert({
          id: userId,
          ...updates,
          updated_at: new Date().toISOString(),
        }, {
          onConflict: 'id'  // Specify the conflict column
        })
        .select()
        .single();

      if (error) {
        console.error("❌ Error updating profile:", error);
        console.error("Error details:", {
          message: error.message,
          details: error.details,
          hint: error.hint,
          code: error.code
        });
        throw error;
      }
      
      console.log("✅ Profile updated:", data);
      return data;
    } catch (error) {
      console.error("❌ Failed to update profile:", error);
      return null;
    }
  }
}

export const profileService = new ProfileService();